<template>
  <div>
    <el-row v-for="(r,i) in value" :key="i">
      <el-form-item label="权重" style="margin-top: 10px;">
        <el-input v-model.number="r.v" style="width: 130px;" placeholder="权重" />
      </el-form-item>
      <el-form-item label="道具" style="margin-top: 10px;">
        <el-select v-model.number="r.propsId" style="width: 130px;" placeholder="请选择">
          <el-option
            v-for="(item, index) in rewardType"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="skinId.includes(r.propsId)" style="margin-top: 10px;" label="选择皮肤">
        <el-select v-if="r.propsId === 62" v-model.number="r.skin" placeholder="请选择" style="width: 120px">
          <el-option
            v-for="item in chessId"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>

        <el-select v-if="r.propsId === 19" v-model.number="r.skin" placeholder="请选择" style="width: 120px">
          <el-option
            v-for="item in areaId"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>

        <el-select v-if="r.propsId === 67" v-model.number="r.skin" placeholder="请选择" style="width: 120px">
          <el-option
            v-for="item in shield"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>

        <el-select v-if="r.propsId === 68" v-model.number="r.skin" placeholder="请选择" style="width: 120px">
          <el-option
            v-for="item in sieve"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item v-if="skinId.includes(r.propsId) || box.includes(r.propsId)" label="奖品数量" style="margin-top: 10px;">
        <el-input v-model.number="r.num" style="width: 130px;" placeholder="奖品数量" />
      </el-form-item>
      <el-form-item v-if="normal.includes(r.propsId)">
        <el-button style="margin-top: 10px;" type="primary" @click="langVisibleArr[i].visible = true">配置</el-button>
        <el-dialog :before-close="(d)=>{return handleClose(d, i)}" append-to-body style="overflow-y: auto" title="配置" width="1800px" :visible="langVisibleArr[i].visible" @open="openWeight(i)">
          <el-row :gutter="10" class="mb8" style="margin-top: 10px;">
            <el-col :span="1.5">
              <el-upload
                :ref="upload"
                class="upload-demo"
                :action="sys_app_logoAction"
                accept="xlsx"
                :limit="1"
                :on-success="(res)=>{return importUploadSuccess(res, r.propsId, id, i)}"
                :headers="headers"
              >
                <el-button icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
              </el-upload>
            </el-col>

            <el-col :span="1.5">
              <el-button
                type="primary"
                icon="el-icon-download"
                size="mini"
                @click="exportData(id, r.propsId)"
              >导出</el-button>
            </el-col>
          </el-row>

          <el-form>
            <el-table :data="weightData" border stripe>
              <el-table-column prop="lv" label="等级">
                <template slot-scope="scope">
                  <span>{{ scope.row.lv }}</span>
                </template>
              </el-table-column>
              <el-table-column v-for="(item, index) in weightNumber" :key="index" :label="'权重'+item">
                <template slot-scope="scope">
                  <span>{{ scope.row.weight[index].num }}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <!--                  <el-button @click="langVisibleArr[index].visible = false">取 消</el-button>-->
            <el-button type="primary" @click="langVisibleArr[index].visible = false">确 定</el-button>
          </div>
        </el-dialog>

      </el-form-item>
      <el-form-item style="margin-top: 10px;">
        <el-button type="danger" @click="removeReward(i)">删除</el-button>
      </el-form-item>
    </el-row>
    <el-form-item style="margin-top: 20px">
      <el-button type="primary" @click="addReward()">+</el-button>
    </el-form-item>
  </div>
</template>

<script>
import { getAnimalAllList, getShieldsAllList, getSieveAllList } from '@/api/config/area-cfg'
import { getRewardType } from '@/api/config/slot'
import { getToken } from '@/utils/auth'
import { exportBuildBoxVCfg, importBuildBoxVCfg } from '@/api/config/blind-box-cfg'

export default {
  name: 'Reward',
  props: {
    id: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: () => []
    },
    refreshTables: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      upload: '',
      weightNumber: {},
      weightData: [],
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      langVisibleArr: [],
      selectType: [
        {
          'id': 1,
          'title': '只取数量'
        },
        {
          'id': 2,
          'title': '等级取值'
        }
      ],
      normal: [14, 15, 22, 65],
      skinId: [62, 19, 67, 68],
      box: [1, 2, 3],
      chessId: [],
      areaId: [],
      shield: [],
      sieve: [],
      rewardType: []
    }
  },
  watch: {
    value: function(newVal) {
      this.$emit('input', newVal)
    }
  },
  created() {
    this.initVisible()
    this.getRewardTypeData()
    this.getShieldsId()
    this.getSieveId()
    this.getChessId()
  },
  methods: {
    handleClose(d, i) {
      this.langVisibleArr[i].visible = false
    },
    getTables() {
      this.refreshTables()
    },
    exportData(id, propsId) {
      exportBuildBoxVCfg({ id: id, type: propsId }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importUploadSuccess(response, propsId, id, index) {
      // this.$refs['upload'].clearFiles()
      importBuildBoxVCfg({ data: response.data.path, id: id, type: propsId }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
          setTimeout(() => {
            this.openWeight(index)
          }, 800)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    openWeight(index) {
      this.weightNumber = []
      this.weightData = this.value[index].pro
      if (!this.weightData) {
        this.weightData = []
        return
      }
      if (this.weightData.length > 0) {
        const len = this.weightData[0].weight.length
        for (let i = 0; i < len; i++) {
          this.weightNumber[i] = this.weightData[0].weight[i].v
        }
      }

      console.log(' this.weightNumber ', this.weightNumber)
    },
    initVisible() {
      this.langVisibleArr = []
      this.value.forEach(res => {
        this.langVisibleArr.push({ visible: false })
      })
    },
    getChessId() {
      getAnimalAllList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.chessId.push({ 'label': res.data[i].lang_key, 'value': parseInt(res.data[i].id) })
          }
        }
      })
    },
    getShieldsId() {
      getShieldsAllList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.shield.push({ 'label': res.data[i].lang_key, 'value': parseInt(res.data[i].id) })
          }
        }
      })
    },
    getSieveId() {
      getSieveAllList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.sieve.push({ 'label': res.data[i].lang_key, 'value': parseInt(res.data[i].id) })
          }
        }
      })
    },
    getRewardTypeData(ucType) {
      getRewardType({ data: ucType }).then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            const prodId = parseInt(i)
            if (prodId === 71) {
              continue
            }
            this.rewardType.push({ 'label': res.data[i], 'value': prodId })
          }
        }
      })
    },
    addReward() {
      this.value.push({
        propsId: 1,
        num: 1,
        skin: 1,
        v: 1,
        pro: []
      })
      this.langVisibleArr.push({ visible: false })
    },
    removeReward(zIndex) {
      this.value = this.value.filter((item, i) => {
        return i !== zIndex
      })
    }
  }
}
</script>

<style scoped>

</style>
